import React from 'react'
import styles from './FooterDetails.module.css'

const TermsAndConditions = () => {
  return (
    <div className={styles.FooterDetails}>
      <h1 className={styles.title}>Terms and Conditions</h1>
      <h3 className={styles.heading}>Introduction</h3>
      <p className={styles.body}>
        These terms and conditions ("Terms and Conditions") govern your use of
        the website www.smartranx.com ("Website"). In these Terms and
        Conditions, "Smartranx Education Center" is referred to as the
        "Company," "us," or "we."
      </p>
      <br />
      <h3 className={styles.heading}>Ownership and Usage</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Ownership: </span>
        The website, educational services, and content provided through the site
        (collectively referred to as the "Company Products") are owned,
        operated, and maintained by Smartranx Education Center.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Agreement: </span>By accessing or
        using the Company Products, you agree to be bound by these Terms and
        Conditions.
      </p>
      <br />
      <h3 className={styles.heading}>User Agreement</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Acceptance: </span>By using this
        website or its Products and Services, you agree and warrant that you
        have read, understood, and agreed to be bound by these terms.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Privacy Policy: </span>Please refer
        to our Privacy Policy for information on how we collect, use, and
        protect your personal information.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Updates: </span>The Site is subject
        to periodic updates and revisions. Smartranx Education Center reserves
        the right to modify information on the Site without prior notice.
      </p>
      <br />
      <h3 className={styles.heading}>Limitation of Liability</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Financial Performance: </span>Past
        financial performance is not indicative of future performance. Smartranx
        Education Center does not guarantee future performance.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>No Liability: </span>Under no
        circumstances will Smartranx Education Center be liable for any errors,
        omissions, loss, or damage experienced in connection with the use of our
        Products and Services.
      </p>
      <br />
      <h3 className={styles.heading}>User Responsibilities</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Usage Charges: </span>Users are
        responsible for charges incurred for hardware, software, or internet
        services.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Account Access: </span>Users must
        use login credentials responsibly. Smartranx Education Center reserves
        the right to block access for users who violate these conditions.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Service Interruptions: </span>While
        we aim to provide uninterrupted access, there is no obligation to do so.
        Smartranx Education Center is not responsible for network or server
        issues beyond certain limits.
      </p>
      <br />
      <h3 className={styles.heading}>Copyright and Intellectual Property</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>Ownership: </span>The content on the
        Site is protected by copyright and trademark laws. Users may not
        duplicate, modify, publish, or reproduce the content in any manner
        without permission.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Third-party Content: </span>
        Smartranx Education Center is not responsible for content on external
        sites, except for partners and affiliates. Users must respect
        intellectual property rights.
      </p>
      <br />
      <h3 className={styles.heading}>Intellectual Property Violations</h3>
      <p className={styles.body}>
        If you believe your intellectual property rights have been violated,
        please provide the necessary information to Smartranx Education Center
        for prompt action.
      </p>
      <br />
      <h3 className={styles.heading}>Website Usage Guidelines</h3>
      <p className={styles.body}>
        Users must adhere to guidelines regarding respectful and lawful behavior
        on the website.
      </p>
      <br />
      <h3 className={styles.heading}>Links and Hyperlinks Terms</h3>
      <p className={styles.body}>
        <span className={styles.subHeading}>External Links: </span>Smartranx
        Education Center is not responsible for the content of external websites
        linked on the Site.
      </p>
      <br />
      <p className={styles.body}>
        <span className={styles.subHeading}>Linking Guidelines: </span>
        Users must adhere to guidelines when linking to Smartranx Education
        Center website.
      </p>
      <br />
      <h3 className={styles.heading}>Transaction Terms</h3>
      <p className={styles.body}>
        Users making transactions on Smartranx Education Center website are
        bound to pay for the transaction and adhere to additional terms and
        conditions.
      </p>
      <br />
      <h3 className={styles.heading}>Indemnity</h3>
      <p className={styles.body}>
        Users agree to indemnify and hold Smartranx Education Center harmless
        from any claims arising from their breach of these Terms and Conditions.
      </p>
      <br />
      <h3 className={styles.heading}>Pricing Disclaimer</h3>
      <p className={styles.body}>
        Prices, products, and offers on Smartranx Education Center website are
        subject to change without notice. We strive to provide accurate
        information, but errors may occur.
      </p>
      <br />
      <h3 className={styles.heading}>Limit of Liability</h3>
      <p className={styles.body}>
        Smartranx Education Center shall not be liable for any damages resulting
        from the use of the service, unauthorized access, or any other matter
        related to the Products.
      </p>
      <br />
      <p className={styles.body}>
        Contact UsIf you have any questions or concerns about these Terms and
        Conditions, please contact us at support@smartranx.com.
      </p>
    </div>
  )
}

export default TermsAndConditions
